// This is needed because `ejson` is still using canpoy that produce parser
// that is not using ESM and needs require. Dunno why this is work, just kinda
// brut-forced with debugger.
import "@ejson/ejson.js";
let ExtendedJSON = typeof exports === "object" ? exports : window.ExtendedJSON;

export default ExtendedJSON;
